import React, { useState } from "react";
import { Grid, Button } from "@material-ui/core";
import Markdown from "react-markdown";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore"; // Correct import for the icon
import { makeStyles } from "@material-ui/core/styles";
import { MarkdownListItem } from "./MarkdownListItem";
import { MarkdownLink } from "./MarkdownLink";
import { MarkdownList } from "./MarkdownList";
import { YTVideoModal } from "../YTVideoModal";

const useStyles = makeStyles((theme) => ({
  h: {
    marginBottom: theme.spacing(0),
    marginTop: theme.spacing(0),
  },
}));

const KBMediaModal = ({ media, onClose }) => {
  if (!media) return null;

  const handleClick = () => {
    onClose();
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#00000066",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
      }}
    >
      <video
        controls
        autoPlay
        src={media.url}
        style={{ maxWidth: "90%", maxHeight: "80%" }}
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

const MarkdownViewer = ({
  handleClose,
  setVideoId,
  callBack,
  md,
  hasChildren,
  kbFiles,
  kbMedia,
  openKbMedia,
}) => {
  const classes = useStyles();
  return (
    <Markdown
      components={{
        a(props) {
          return (
            <MarkdownLink
              handleClose={handleClose}
              setVideoId={setVideoId}
              kbFiles={kbFiles}
              kbMedia={kbMedia}
              openKbMedia={openKbMedia}
              {...props}
              callBack={callBack}
            />
          );
        },
        ul: ({ children }) => (
          <div>
            <MarkdownList>{children}</MarkdownList>
          </div>
        ),
        li: MarkdownListItem,
        h1: ({ children }) => <h3 className={classes.h}>{children}</h3>,
        h2: ({ children }) => <h4 className={classes.h}>{children}</h4>,
        h3: ({ children }) => <h5 className={classes.h}>{children}</h5>,
        h4: ({ children }) => <h5 className={classes.h}>{children}</h5>,
        h5: ({ children }) => <h5 className={classes.h}>{children}</h5>,
      }}
    >
      {`${md}${hasChildren ? "\n\n [More](custom/-)" : ""}`}
    </Markdown>
  );
};

const HelpViewer = ({ handleClose, helpPage, children }) => {
  const [state, setState] = useState("main");
  const [videoId, setVideoId] = useState("");
  const [kbMediaState, setKbMediaState] = useState(null);
  const md = helpPage?.content;
  const kbFiles = helpPage?.kbFiles;
  const kbMedia = helpPage?.kbMedia;

  const handleBackClick = () => {
    setState("main");
  };

  const callBack = () => {
    setState("customHelp");
  };

  const openKbMedia = (media) => {
    setKbMediaState(media);
  };

  const handleCloseKbMedia = () => {
    setKbMediaState(null);
  };

  return (
    <>
      {state !== "main" && (
        <Grid item>
          <Button startIcon={<NavigateBeforeIcon />} onClick={handleBackClick}>
            Back
          </Button>
        </Grid>
      )}
      {state === "main" && (
        <MarkdownViewer
          handleClose={handleClose}
          hasChildren={!!children}
          setVideoId={setVideoId}
          callBack={callBack}
          md={md}
          kbFiles={kbFiles}
          kbMedia={kbMedia}
          openKbMedia={openKbMedia}
        />
      )}
      {state === "customHelp" && children}
      {videoId && <YTVideoModal setVideoId={setVideoId} videoId={videoId} />}
      {kbMediaState && (
        <KBMediaModal media={kbMediaState} onClose={handleCloseKbMedia} />
      )}
    </>
  );
};

export { HelpViewer, MarkdownViewer };
